import {
  defFetchList,
  defFetchOne,
  defCreate,
  defUpdateOne,
  defDeleteOne,
  defUpdateStatus,
  defUploadCoverImage
} from '@/api/default'

import request from '@/api/request'

const BASE_PATH = '/branch'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function fetchInlineResource (id) {
  return request({
    url: BASE_PATH + '/' + id + '/inline_rsc',
    method: 'get'
  })
}

export function create (data) {
  return defCreate(BASE_PATH, data)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function deleteOne (id) {
  return defDeleteOne(BASE_PATH, id)
}

export function updateStatus (id, data) {
  return defUpdateStatus(BASE_PATH, id, data)
}

export function uploadCoverImage (id, data, config) {
  return defUploadCoverImage(BASE_PATH, id, data, config)
}
